@use '../../styles/mixins.scss' as mixins;
@use '../../styles/button.scss' as button;
@use '../../styles/surface.scss' as surface;
@use '../../styles/text.scss' as text;
@use '../../styles/typography.scss' as typography;

.wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 8px;

  &.disabled .label {
    @include mixins.disabled(0.5);
  }
}

.track {
  all: unset;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  padding: 2px;
  border-radius: 999px;
  background-color: button.$button-toggle-default;
  cursor: pointer;
  box-sizing: border-box;
  transition: background-color 0.1s ease;

  &.xs {
    width: 28px;
    height: 16px;
    --switch-translate-x: 12px;
  }

  &.s {
    width: 36px;
    height: 20px;
    --switch-translate-x: 16px;
  }

  &.m {
    width: 44px;
    height: 24px;
    --switch-translate-x: 20px;
  }

  &[data-state='checked'] {
    background-color: button.$button-accent-default;

    .thumb {
      transform: translateX(var(--switch-translate-x));
    }
  }

  &:hover:not([data-disabled]) {
    &[data-state='unchecked'] {
      background-color: button.$button-toggle-hover;
    }

    &[data-state='checked'] {
      background-color: button.$button-accent-hover;
    }
  }

  &:focus-visible {
    @include mixins.focus-ring;
  }

  &[data-disabled] {
    @include mixins.disabled(0.3);
  }
}

.thumb {
  flex-shrink: 0;
  border-radius: 50%;
  background-color: surface.$surface-full;
  box-shadow:
    0 1px 3px rgba(0, 0, 0, 0.15),
    0 1px 2px rgba(0, 0, 0, 0.08);
  transition: transform 0.1s ease-out;

  &.xs {
    width: 12px;
    height: 12px;
  }

  &.s {
    width: 16px;
    height: 16px;
  }

  &.m {
    width: 20px;
    height: 20px;
  }
}

.label {
  @include typography.text-m-regular;
  color: text.$text-tertiary;
  cursor: pointer;
  user-select: none;
}
